import * as z from "zod";
import { AVATAR_KEY_REGEX } from "../avatarPolicy";
import { mutator } from "./mutator";

export const setCustomAvatarSchema = z.object({
  key: z.string().regex(AVATAR_KEY_REGEX),
});

export const setCustomAvatar = mutator({
  schema: setCustomAvatarSchema,
  resolve: {},
  permissions: { none: "updates only the calling user’s own avatar" },
  fn: async ({ tx, ctx, args }) => {
    // Skip the optimistic local update — until the server has committed the key,
    // /user-avatars can't resolve its owner, so any Avatar that picks up the new
    // key would 404 and stick in a broken state.
    if (tx.location !== "server") return;
    await tx.mutate.user.update({
      id: ctx.userId,
      customAvatarKey: args.key,
    });
  },
});
